import css from 'styled-jsx/css';

export const toastifyCss = css.global`
  .Toastify__toast-container {
    z-index: var(--zindex-toast);
  }
  .Toastify__toast-container p {
    font-family: var(--toastify-font-family);
  }
  .Toastify__toast-container p strong {
    font-weight: 400;
  }

  .toast-error {
    background: var(--clr-danger);
  }

  .toast-error-pause {
    border-bottom: 5px solid var(--clr-danger);
  }

  .Toastify__toast--info,
  .Toastify__toast--warning {
    background: var(--white);
  }

  .Toastify__progress-bar--warning {
    background: var(--clr-danger) !important;
  }

  .Toastify__progress-bar--error {
    background: var(--clr-primary-3) !important;
  }

  .toast-success,
  .toast-green-bar {
    background: var(--clr-success);
  }

  .toast-green {
    background: var(--clr-quaternary-1);
  }

  .toast-black-text {
    color: var(--black);
  }
`;
